export function ReadOnlyCartController(cartService, restaurantInfoFactory, availabilitiesFactory,
    cartDisplayService, $timeout, $scope, googleAnalyticsTrackingService) {
    'ngInject';
    $scope.displayName = '';
    $scope.displayAddress = '';
    $scope.curCart = null;
    $scope.errorMessage = '';
    $scope.cartDisplay = cartDisplayService.displayData;
    $scope.cartFlags = {
        loading: true,
        hasError: false
    };
    $scope.getCart = getCart;
    $scope.backToMenuEvent = googleAnalyticsTrackingService.getBackToMenuEvent();
    //Set default external loading if it is not passed in to directive
    $scope.externalLoading = angular.isDefined($scope.externalLoading) ? $scope.externalLoading : false;

    activate();

    ///------------------------------------

    function getCart() {
        cartService.getCart()
            .then(function() {
                $scope.cartData = cartService.getCartData();
                $scope.cartFlags.loading = false;
            });
        cartDisplayService.getDisplayData().then(function() {
            $scope.cartDisplay = cartDisplayService.displayData;
        });
    }

    function activate() {
        restaurantInfoFactory.getInfo(['general', 'restaurantAddress'])
            .then(function(info) {
                $scope.displayName = info.general.name;
                availabilitiesFactory.setTimeZone(info.general.timeZone);
                var address = info.restaurantAddress;
                var address2 = address.address2;
                if (address2) {
                    address2 += ', ';
                } else {
                    address2 = '';
                }
                $scope.displayAddress = address.address1 + ', ' + address2 + address.city + ', ' + address.stateCode + ' ' + address.zipCode;
            });

        getCart();
    }
}
